export default "<div id=\"game\"></div>"